export const llaveGlobal: string = '123456';
export const llaveToken: string = 'clave-secreta-api';
